var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let decodeModule, encodeModule;
if (process.env.IS_FIREFOX) {
    decodeModule = require('@hiveio/hive-js/lib/auth/memo');
    encodeModule = require('@hiveio/hive-js/lib/auth/memo');
}
else {
    if (!global.window) {
        //@ts-ignore
        global.window = { crypto };
        decodeModule = require('@hiveio/hive-js/lib/auth/memo');
        encodeModule = require('@hiveio/hive-js/lib/auth/memo');
    }
}
import AccountUtils from '@popup/steem/utils/account.utils';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { KeychainKeyTypes } from '@steempro/steem-keychain-commons';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
const getUsernameFromTransaction = (tx) => {
    var _a, _b, _c, _d, _e, _f, _g;
    let username;
    if (!tx.operations || !tx.operations.length)
        return;
    for (const op of tx.operations) {
        if (!op[0] || !op[1] || typeof op[1] !== 'object')
            return;
        let newUsername;
        switch (op[0]) {
            case 'account_create':
                newUsername = op[1].creator;
                break;
            case 'account_create_with_delegation':
                newUsername = op[1].creator;
                break;
            case 'account_update':
                newUsername = op[1].account;
                break;
            case 'account_update2':
                newUsername = op[1].account;
                break;
            case 'account_witness_proxy':
                newUsername = op[1].account;
                break;
            case 'account_witness_vote':
                newUsername = op[1].account;
                break;
            case 'cancel_transfer_from_savings':
                newUsername = op[1].from;
                break;
            case 'change_recovery_account':
                newUsername = op[1]
                    .account_to_recover;
                break;
            case 'claim_account':
                newUsername = op[1].creator;
                break;
            case 'claim_reward_balance':
                newUsername = op[1].account;
                break;
            case 'comment':
                newUsername = op[1].author;
                break;
            case 'comment_options':
                newUsername = op[1].author;
                break;
            case 'convert':
                newUsername = op[1].owner;
                break;
            case 'create_claimed_account':
                newUsername = op[1].creator;
                break;
            case 'create_proposal':
                newUsername = op[1].creator;
                break;
            case 'custom':
                newUsername = (_a = op[1].required_auths) === null || _a === void 0 ? void 0 : _a[0];
                break;
            case 'custom_binary':
                newUsername =
                    ((_b = op[1].required_auths) === null || _b === void 0 ? void 0 : _b[0]) ||
                        ((_c = op[1].required_posting_auths) === null || _c === void 0 ? void 0 : _c[0]) ||
                        ((_d = op[1].required_active_auths) === null || _d === void 0 ? void 0 : _d[0]) ||
                        ((_e = op[1].required_owner_auths) === null || _e === void 0 ? void 0 : _e[0]);
                break;
            case 'custom_json':
                newUsername =
                    ((_f = op[1].required_auths) === null || _f === void 0 ? void 0 : _f[0]) ||
                        ((_g = op[1].required_posting_auths) === null || _g === void 0 ? void 0 : _g[0]);
                break;
            case 'decline_voting_rights':
                newUsername = op[1].account;
                break;
            case 'delegate_vesting_shares':
                newUsername = op[1].delegator;
                break;
            case 'delete_comment':
                newUsername = op[1].author;
                break;
            case 'escrow_approve':
                newUsername = op[1].who;
                break;
            case 'escrow_dispute':
                newUsername = op[1].who;
                break;
            case 'escrow_release':
                newUsername = op[1].who;
                break;
            case 'escrow_transfer':
                newUsername = op[1].from;
                break;
            case 'feed_publish':
                newUsername = op[1].publisher;
                break;
            case 'limit_order_cancel':
                newUsername = op[1].owner;
                break;
            case 'limit_order_create':
                newUsername = op[1].owner;
                break;
            case 'limit_order_create2':
                newUsername = op[1].owner;
                break;
            case 'pow':
                newUsername = op[1].worker_account;
                break;
            case 'recover_account':
                newUsername = op[1].account_to_recover;
                break;
            case 'report_over_production':
                newUsername = op[1].reporter;
                break;
            case 'request_account_recovery':
                newUsername = op[1]
                    .account_to_recover;
                break;
            case 'reset_account':
                newUsername = op[1].account_to_reset;
                break;
            case 'set_reset_account':
                newUsername = op[1].account;
                break;
            case 'set_withdraw_vesting_route':
                newUsername = op[1].from_account;
                break;
            case 'transfer':
                newUsername = op[1].from;
                break;
            case 'transfer_from_savings':
                newUsername = op[1].from;
                break;
            case 'transfer_to_savings':
                newUsername = op[1].from;
                break;
            case 'transfer_to_vesting':
                newUsername = op[1].from;
                break;
            case 'vote':
                newUsername = op[1].voter;
                break;
            case 'withdraw_vesting':
                newUsername = op[1].account;
                break;
            case 'witness_set_properties':
                newUsername = op[1].owner;
                break;
            case 'witness_update':
                newUsername = op[1].owner;
                break;
            case 'remove_proposal':
                newUsername = op[1].proposal_owner;
                break;
            case 'update_proposal_votes':
                newUsername = op[1].voter;
                break;
        }
        if (username && username !== newUsername)
            return;
        else
            username = newUsername;
    }
    return username;
};
const saveMultisigConfig = (account, newAccountConfig) => __awaiter(void 0, void 0, void 0, function* () {
    let config = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.MULTISIG_CONFIG);
    if (!config)
        config = {};
    config[account] = newAccountConfig;
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.MULTISIG_CONFIG, config);
});
const getMultisigAccountConfig = (account) => __awaiter(void 0, void 0, void 0, function* () {
    const multisigConfig = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.MULTISIG_CONFIG);
    if (!multisigConfig)
        return null;
    return multisigConfig[account];
});
const encodeTransaction = (transaction, key, receiverPubKey) => __awaiter(void 0, void 0, void 0, function* () {
    return encodeModule.encode(key, receiverPubKey, `#${JSON.stringify(transaction)}`);
});
const encodeMetadata = (metadata, key, receiverPubKey) => __awaiter(void 0, void 0, void 0, function* () {
    return encodeModule.encode(key, receiverPubKey, `#${JSON.stringify(metadata)}`);
});
const decodeTransaction = (message, key) => __awaiter(void 0, void 0, void 0, function* () {
    if (decodeModule) {
        try {
            const decodedMessage = yield decodeModule.decode(key, message);
            const stringifiedTx = decodedMessage.substring(1);
            const parsedTx = JSON.parse(stringifiedTx);
            return parsedTx;
        }
        catch (err) {
            Logger.error('Error while decoding the transaction', err);
        }
    }
});
const getPotentialSigners = (account, key, method) => __awaiter(void 0, void 0, void 0, function* () {
    const authority = method === KeychainKeyTypes.active ? account === null || account === void 0 ? void 0 : account.active : account === null || account === void 0 ? void 0 : account.posting;
    let receivers = [];
    if (authority) {
        for (let i = 0; i < authority.account_auths.length; i++) {
            const pk = yield getPublicKeys(authority.account_auths[i][0], method);
            if (pk) {
                for (let k = 0; k < pk.length; k++) {
                    receivers.push([pk[k].toString(), authority.account_auths[i][1]]);
                }
            }
        }
        for (let k = 0; k < authority.key_auths.length; k++) {
            receivers.push([
                authority.key_auths[k][0].toString(),
                authority.key_auths[k][1],
            ]);
        }
    }
    return receivers.filter((r) => r[0] !== KeysUtils.getPublicKeyFromPrivateKeyString(key));
});
const getPublicKeys = (username, keyType) => __awaiter(void 0, void 0, void 0, function* () {
    const account = yield AccountUtils.getExtendedAccount(username);
    if (account) {
        switch (keyType) {
            case KeychainKeyTypes.active:
                return account.active.key_auths.map((key) => {
                    return key[0];
                });
            case KeychainKeyTypes.posting:
                return account.posting.key_auths.map((key) => {
                    return key[0];
                });
            default:
                return undefined;
        }
    }
    return undefined;
});
const isMultisigCompatible = () => {
    var _a, _b, _c;
    const chromeVersion = ((_c = (_b = (_a = /Chrome\/([0-9.]+)/.exec(navigator.userAgent)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('.')) === null || _c === void 0 ? void 0 : _c[0]) || 0;
    return process.env.IS_FIREFOX || +chromeVersion >= 116;
};
const get2FAAccounts = (account, method) => __awaiter(void 0, void 0, void 0, function* () {
    let potentialBots;
    switch (method) {
        case KeychainKeyTypes.active: {
            potentialBots = account.active.account_auths.map(([username, weigth]) => {
                return username;
            });
            break;
        }
        case KeychainKeyTypes.posting: {
            potentialBots = account.posting.account_auths.map(([username, weigth]) => {
                return username;
            });
            break;
        }
    }
    if (!potentialBots) {
        return [];
    }
    const extendedAccounts = yield AccountUtils.getExtendedAccounts(potentialBots);
    const botNames = [];
    for (const extendedAccount of extendedAccounts) {
        let metadata;
        try {
            metadata = JSON.parse(extendedAccount['json_metadata']);
        }
        catch (e) {
            continue;
        }
        if (metadata.isMultisigBot) {
            botNames.push(extendedAccount.name);
        }
    }
    return botNames;
});
const getTwoFaBotUserConfig = (configPath, username) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => {
        try {
            fetch(`${configPath.replace(':username', username)}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })
                .then((res) => {
                if (res && res.status === 200) {
                    return res.json();
                }
            })
                .then((res) => {
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        }
        catch (err) {
            reject(err);
        }
    });
});
export const MultisigUtils = {
    get2FAAccounts,
    getUsernameFromTransaction,
    saveMultisigConfig,
    getMultisigAccountConfig,
    decodeTransaction,
    encodeTransaction,
    encodeMetadata,
    getPotentialSigners,
    isMultisigCompatible,
};
